import React from "react";
import PrivateRoute from "common/routes/PrivateRoute/PrivateRoute";

export default function RecepcionProtectedRoute(props){
    return <PrivateRoute allowedroles={["cierre-bancario","libros-contables",'administrator','recepcion','notas-debito',
    'conciliacion','facturas','ec']}>
        {props.children}
    </PrivateRoute>;
}
